import React from "react"
import { useNoteContext } from "./note-context"

export type NoteHeadingProps = {
  children: React.ReactNode
  /** The heading level, to fit the heading order around the note. It sets the tag only, so the heading looks the same at every level. Defaults to `2`. */
  level?: 2 | 3 | 4 | 5 | 6
}

export function NoteHeading({ children, level = 2 }: NoteHeadingProps) {
  const { headingId, registerHeading } = useNoteContext()
  const HeadingTag = `h${level}` as const

  React.useLayoutEffect(() => registerHeading(), [registerHeading])

  return (
    <HeadingTag
      className="font-semibold"
      data-slot="note-heading"
      id={headingId}
    >
      {children}
    </HeadingTag>
  )
}
